import { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'

import { AccordionItem } from '../Accordion/Accordion'
import Markdown from '../Markdown/Markdown'

import styles from './FaqSection.module.scss'

const FaqSection = () => {
  const { sectiondata } = useOutletContext() || {}
  const [activeIndex, setActiveIndex] = useState(null)

  useEffect(() => {
    setActiveIndex(null)
  }, [])

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return (
    <section className={styles['faq-section']}>
      <div className={styles.container}>
        <div className={styles.accordion}>
          {sectiondata.questions &&
            sectiondata.questions.length > 0 &&
            sectiondata.questions.map((item, index) => (
              <AccordionItem
                key={'faq' + item?.id}
                question={item.question}
                isOpen={activeIndex === index}
                onClick={() => handleClick(index)}
              >
                <Markdown
                  content={item.answer}
                  className={styles.faqsMarkdown}
                />
              </AccordionItem>
            ))}
        </div>
      </div>
    </section>
  )
}

export default FaqSection
